import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import { useNavigate, useParams } from "react-router-dom";

const PRODUCTS_URL = "/api/product";

function EditMeal() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [formData, setFormData] = useState({
        name: "",
        category: "",
        price: "",
        logo: null,
    });

    useEffect(() => {
        const fetchMeal = async () => {
            try {
                const response = await axios.get(`${PRODUCTS_URL}/${id}`);
                const { name, category, price, logo } = response.data;
                setFormData({ name, category, price, logo: null });
            } catch (error) {
                console.error("Error fetching meal:", error);
                alert("Failed to fetch meal details");
            }
        };

        fetchMeal();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, logo: e.target.files[0] });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const { logo, ...mealData } = formData;

            await axios.put(`${PRODUCTS_URL}/${id}`, mealData);

            if (formData.logo) {
                const fileData = new FormData();
                fileData.append("file", formData.logo);

                await axios.put(`/api/product/upload/${id}`, fileData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            }

            navigate('/menu');
        } catch (error) {
            console.error("Error updating meal:", error);
            alert("Failed to update meal");
        }
    };

    return (
        <div className="max-w-5xl mx-auto p-10 bg-white rounded-lg shadow-lg transition duration-300 hover:shadow-2xl">
            <h2 className="text-4xl font-bold mb-8 text-[#4335A7] text-center">Edit Meal or Drink</h2>
            <form onSubmit={handleSubmit} className="space-y-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="flex flex-col">
                        <label htmlFor="name" className="text-lg font-medium text-[#2c3e50] mb-2">Meal/Drink Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter Meal or Drink Name"
                            className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4335A7] transition duration-200 shadow-lg"
                            required
                        />
                    </div>
                    <div className="flex flex-col">
                        <label htmlFor="category" className="text-lg font-medium text-[#2c3e50] mb-2">Category</label>
                        <select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4335A7] transition duration-200 shadow-lg"
                            required
                        >
                            <option value="">Select Category</option>
                            <option value="TEA">THÉ / TEA</option>
                            <option value="COFFEE">CAFÉ / COFFEE</option>
                            <option value="JUICE">JUS / JUICE</option>
                            <option value="MOCKTAILS">MOCKTAILS</option>
                            <option value="WATERS">EAUX ET SODAS / WATERS & SODAS</option>
                            <option value="BEER">BIÈRE / BEER</option>
                            <option value="SALAD">SALADE / SALAD</option>
                            <option value="BURGER">BURGER</option>
                            <option value="SANDWICH">SANDWICH</option>
                            <option value="OMELETTE">OMELETTE</option>
                            <option value="PLATS">PLATS</option>
                            <option value="HARIRA">HARIRA</option>
                            <option value="TAGINE">TAGINE</option>
                            <option value="COUSCOUS">COUSCOUS</option>
                            <option value="DESSERTS">DESSERTS</option>
                        </select>
                    </div>
                    <div className="flex flex-col">
                        <label htmlFor="price" className="text-lg font-medium text-[#2c3e50] mb-2">Price</label>
                        <input
                            type="number"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            placeholder="Enter Price"
                            className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#4335A7] transition duration-200 shadow-lg"
                            min="0"
                            required
                        />
                    </div>
                </div>
                <div className="flex flex-col">
                    <label htmlFor="logo" className="text-lg font-medium text-[#2c3e50] mb-2">Meal/Drink Logo</label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="w-full p-4 border border-gray-300 rounded-lg bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[#4335A7] transition duration-200 hover:bg-gray-200 cursor-pointer shadow-lg"
                        id="file-upload"
                    />
                </div>
                <button type="submit" className="w-full bg-[#4335A7] text-white p-4 rounded-lg text-lg hover:bg-[#5a3fbb] transition duration-200 shadow-lg hover:shadow-xl">
                    Update Meal/Drink
                </button>
            </form>
        </div>
    );
}

export default EditMeal;
